document.addEventListener('DOMContentLoaded', function () {
    // Datele simulative ale comenzilor
    var orders = [
        { name: 'Andrei Popescu', quantity: 2, city: 'București' },
        { name: 'Maria Ionescu', quantity: 1, city: 'Cluj-Napoca' },
        { name: 'Ion Vasilescu', quantity: 3, city: 'Timișoara' },
        { name: 'Elena Georgescu', quantity: 4, city: 'Iași' },
        { name: 'Mihai Dumitrescu', quantity: 1, city: 'Constanța' },
        { name: 'Cristina Stoica', quantity: 2, city: 'Craiova' },
        { name: 'Adrian Vasile', quantity: 1, city: 'Brașov' },
        { name: 'Ana Radu', quantity: 3, city: 'Galați' },
        { name: 'Gabriel Iacob', quantity: 2, city: 'Ploiești' },
        { name: 'Ioana Bălan', quantity: 1, city: 'Oradea' },
        { name: 'Florin Munteanu', quantity: 4, city: 'Brăila' },
        { name: 'Laura Voicu', quantity: 1, city: 'Arad' },
        { name: 'Roxana Neagu', quantity: 3, city: 'Pitești' },
        { name: 'Dan Pavel', quantity: 2, city: 'Sibiu' },
        { name: 'Alina Mihăilescu', quantity: 1, city: 'Bacău' },
        { name: 'Costin Popa', quantity: 3, city: 'Târgu Mureș' },
        { name: 'Simona Drăghici', quantity: 2, city: 'Baia Mare' },
        { name: 'Victor Nistor', quantity: 1, city: 'Buzău' },
        { name: 'Monica Oprea', quantity: 4, city: 'Satu Mare' },
        { name: 'Radu Preda', quantity: 1, city: 'Suceava' },
        { name: 'Silvia Roman', quantity: 3, city: 'Râmnicu Vâlcea' },
        { name: 'George Florescu', quantity: 2, city: 'Focșani' },
        { name: 'Carmen Teodorescu', quantity: 1, city: 'Botoșani' },
        { name: 'Diana Alexandrescu', quantity: 4, city: 'Târgu Jiu' },
        { name: 'Marius Ene', quantity: 1, city: 'Tulcea' },
        { name: 'Sorina Ilie', quantity: 3, city: 'Reșița' },
        { name: 'Răzvan Marin', quantity: 2, city: 'Bistrița' },
        { name: 'Daniela Luca', quantity: 1, city: 'Slatina' },
        { name: 'Tudor Anghel', quantity: 4, city: 'Vaslui' },
        { name: 'Natalia Dima', quantity: 1, city: 'Alba Iulia' },
        { name: 'Liviu Matei', quantity: 3, city: 'Deva' },
        { name: 'Paula Pop', quantity: 2, city: 'Hunedoara' },
        { name: 'Alexandra Borcea', quantity: 1, city: 'Zalău' },
        { name: 'Emil Gherman', quantity: 4, city: 'Sfântu Gheorghe' },
        { name: 'Valentina Onofrei', quantity: 1, city: 'Giurgiu' },
        { name: 'Claudiu Cojocaru', quantity: 3, city: 'Târgoviște' },
        { name: 'Lavinia Antonescu', quantity: 2, city: 'Piatra Neamț' },
        { name: 'Bogdan Șerban', quantity: 1, city: 'Alexandria' },
        { name: 'Adela Ifrim', quantity: 4, city: 'Slobozia' },
        { name: 'Nicoleta Tănase', quantity: 1, city: 'Călărași' },
        { name: 'Violeta Croitoru', quantity: 3, city: 'Vulcan' },
        { name: 'Cristian Grigore', quantity: 2, city: 'Mangalia' },
        { name: 'Sofia Varga', quantity: 1, city: 'Medgidia' },
        { name: 'Mircea Mihai', quantity: 4, city: 'Caracal' },
        { name: 'Eugenia Pavel', quantity: 1, city: 'Făgăraș' },
        { name: 'Doru Rusu', quantity: 3, city: 'Curtea de Argeș' },
        { name: 'Eliza Timofte', quantity: 2, city: 'Oltenița' },
        { name: 'Oana Zaharia', quantity: 1, city: 'Petroșani' }
    ];

    function showNotification(order) {
        var notification = document.createElement('div');
        notification.className = 'order-notification';
        notification.innerText = order.name + ' a comandat ' + order.quantity + ' produse din ' + order.city;
        
        document.body.appendChild(notification);
        
        setTimeout(function() {
            notification.remove();
        }, 5000); // Afișează notificarea timp de 5 secunde
    }

    function getRandomOrder() {
        return orders[Math.floor(Math.random() * orders.length)];
    }

    setInterval(function() {
        showNotification(getRandomOrder());
    }, 10000); // Afișează o nouă notificare la fiecare 10 secunde
});
